let allOverlayBlocks = document.querySelectorAll('[data-overlay-block]');
// console.log("allOverlayBlocks", allOverlayBlocks);
let parentElement;
// console.log("parentElement",parentElement.offsetWidth);
allOverlayBlocks.forEach(allOverlayBlock => {
    parentElement = allOverlayBlock.closest('label');
    allOverlayBlock.style.width = `${parentElement.offsetWidth}px`;
})